import { createContext, createRef, CSSProperties, FC, ReactElement, ReactNode, useCallback, useContext, useEffect, useRef } from "react"
import { Home } from "./routes";
import cx from 'classnames'
import style from './AnchorContext.module.scss'
import { debounce } from "debounce";
import React from "react";
import mergeRefs from "react-merge-refs";
import { useWindowSize } from "./utils";

type IAnchorContext = {
    anchor: string,
    setCurrentAnchor: (newColor: string) => void

  }
  
export const AnchorContext = createContext<IAnchorContext>({anchor: '', setCurrentAnchor: () => {}})

type AnchorSectionProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLElement>,
  HTMLElement
> 


class Anchor {
  id: string;
  shouldScrollSelfIntoView = false;
  ref: React.RefObject<HTMLElement>= createRef()
  constructor(id: string){
    this.id = id;
  }

  Section = React.forwardRef((_props: AnchorSectionProps, externalRef) => {

    const {
      children,
    
      ...props
    } = _props
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { anchor, setCurrentAnchor } = useContext(AnchorContext);
    // eslint-disable-next-line react-hooks/rules-of-hooks

    const {width} = useWindowSize()
    const headerHeight = width && width > 770 ? 90 : 60;
   
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        const onscroll =  debounce(() => {
        const rect = this.ref.current?.getBoundingClientRect();
        if(!rect){
          
          return
        }
        // 
        const top = rect.top;
        const height = rect.height;
        const bottom = rect.bottom
        // 
        if(top <= headerHeight && bottom > headerHeight ){
          // if(anchor !== this.id){
            
            setCurrentAnchor(this.id)
          // }
        }
      }, 10);
      window.addEventListener('scroll', onscroll)
      return () => {window.removeEventListener('scroll', onscroll)}
    }, [anchor, headerHeight, setCurrentAnchor]);
    
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      
      
      if(this.shouldScrollSelfIntoView){
        
        this.ref.current?.scrollIntoView({behavior: 'smooth'})
        this.shouldScrollSelfIntoView = false
      }
    }, [])
  
    return (
      <section ref={mergeRefs([this.ref, externalRef])} id={this.id} {...props} className={cx(props.className)} style={{scrollMargin: headerHeight-4}}>
        {children}
      </section>
    );
  })

  Link : FC<{  thisPage?: boolean }> = ({

      children,
      thisPage,
    }) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const {width} = useWindowSize()
    const headerHeight = width && width > 770 ? 70 : 60;
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const onClick = useCallback(
        (e) => {
          e.preventDefault();
    
          // this.ref.current?.scrollIntoView({
          //   behavior: "smooth",
          //   block: 'start'
          // });
          if(this.id == 'About'){
            window.scrollTo({top: 0, behavior: 'smooth'}); 
            return
          }
          if(this.ref.current){

            const y = this.ref.current.getBoundingClientRect().top + window.pageYOffset - (headerHeight - 4);
            
            window.scrollTo({top: y, behavior: 'smooth'});
          }
        },
        []
      );

      // eslint-disable-next-line react-hooks/rules-of-hooks
      const { anchor } = useContext(AnchorContext);
    
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const isHome = Home.useIsCurrentRoute();
    
      if (isHome || thisPage) {
        return (
          <a href={'#' + this.id} onClick={onClick} className={cx({'active': anchor === this.id}, 'locallink')} data-id={this.id}>
            {children}
          </a>
        );
      } else {
        
        return <Home.Link onClick={() => {
          this.shouldScrollSelfIntoView = true;
        }}>{children}</Home.Link>;
      }
    };
}


export const About = new Anchor('About')
export const ProperCare = new Anchor('ProperCare')
export const Videos = new Anchor('Videos')
export const ToBuy = new Anchor('ToBuy')
export const ReadMoreAnchor = new Anchor('')
export const ArticleAncor = new Anchor('')